import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useNavigate,
  Redirect,
  useLocation,
} from "react-router-dom";
import PrivateRoutes from "../../utils/PrivateRoutes";
import Login from "../Login";
import Index from "../Dashboards/Index";
// import NotFound from "../NotFound/NotFound";
// import Settings from "../Dashboards/Settings";
import $ from "jquery";
import Swal from "sweetalert2";
// import Services from "../Dashboards/Services/Services";
// import CPs from "../Dashboards/CPs/CPs";
// import CreateServices from "../Dashboards/Services/CreateServices";
// import CreateCP from "../Dashboards/CPs/CreateCP";
// import UnSubscription from "../Dashboards/UnSubscription/UnSubscription";
import { API_ROUTES } from "../../utils/constants";
import Revenue from "../Dashboards/Revenue__";
import Create from "../Dashboards/Create";
import RevenueReport from "../Dashboards/RevenueReport/RevenueReport";
import ListOfMarketers from "../Dashboards/Marketer/ListOfMarketers";
// import MarketersDashboard from "../Dashboards/MarketersDashboard";
import ForgotPassword from "../ForgotPassword";
import CompanyReportTable from "../Dashboards/Company/CompanyReportTable";
import ListOfCompany from "../Dashboards/Company/ListOfCompany";
import UpdateMarketer from "../Dashboards/Marketer/UpdateMarketer";
import DeleteMarketer from "../Dashboards/Marketer/DeleteMarketer";
import MarketerDetails from "../Dashboards/Marketer/MarketerDetails";
import CreateMarketers from "../Dashboards/Marketer/CreateMarketers";
import CompanyDashboard from "../Dashboards/Marketer/CompanyDashboard";
import SingleMarketerDashboard from "../Dashboards/Marketer/SingleMarketerDashboard";
import CreateCompany from "../Dashboards/Company/CreateCompany";
import UpdateCompany from "../Dashboards/Company/UpdateCompany";
import DeleteCompany from "../Dashboards/Company/DeleteCompany";
import AdminPrivateRoutes from "../../utils/AdminPrivateRoutes";
import CompanyDashboardPrivateRoutes from "../../utils/CompanyDashboardPrivateRoutes";
import FilterData from "../Dashboards/FilterData/FilterData";
import IndividualCompanyDashboard from "../Dashboards/Company/IndividualCompanyDashboard";
// import TestModule from "../Dashboards/Company/TestModule";
import TestModule from "../Dashboards/Company/TestModule";
import ListOfProducts from "../../Pages/Product/ListOfProducts";
import CreateProduct from "../../Pages/Product/CreateProduct";
import UpdateProduct from "../../Pages/Product/UpdateProduct";
import DeleteProduct from "../../Pages/Product/DeleteProduct";
import DownloadData from "../Dashboards/DownloadData/DownloadData";
export default function RouterComponent({ getRandomThreeDigitNumber }) {
  const userData = JSON.parse(localStorage.getItem("userVASData"));
  const navigate = useNavigate();

  const objectToFormData = (obj) => {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
      formData.append(key, value);
    });
    return formData;
  };

  const capitalizeWords = (string) => {
    const words = string.split(" ");
    const capitalizedWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedWords.join(" ");
  };

  const errorFunction = (error) => {
    if (
      error.response.status.toString() === "400" ||
      error.response.status.toString() === "401"
    ) {
      Swal.fire({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
      });
    } else {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
      });
    }
  };

  // useEffect(() => {
  //     var flapt_window = $(window);
  //     flapt_window.on('load', function () {
  //         $('#preloader').fadeOut('slow', function () {
  //             $(this).remove();
  //         });
  //     });
  // }, []);

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true); // Marks that loading is complete
    }, 500); // 500ms to simulate preloader fadeout

    return () => clearTimeout(timer); // Cleanup timeout
  }, []);

  const isAuthExpired = (responseJSON) => {
    if (
      responseJSON.status.toString() === "900" ||
      responseJSON.message.toString() === "Authentication Failed"
    ) {
      localStorage.removeItem("userVASData");
      navigate("/login");
      return true;
    } else {
      return false;
    }
  };

  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const today = new Date();

  function resetTimeToMidnight(dateTimeStr) {
    const [date, _] = dateTimeStr.split(" ");
    return `${date} 00:00:00`;
  }

  function resetTimeToB4Midnight(dateTimeStr) {
    const [date, _] = dateTimeStr.split(" ");
    return `${date} 23:59:59`;
  }

  const formatDate1 = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const location = useLocation();
  const [allCPs, setAllCPs] = useState([]);
  const [isLoading1, setIsLoading1] = useState(false);

  const getAllCPS = async () => {
    setIsLoading1(true);
    try {
      const response = await fetch(API_ROUTES.VIEW_CP, {
        method: "POST",
        headers: { token: global.tokens || userData?.responseDetails?.token },
      });
      const responseJSON = await response.json();

      if (global.tokens === "") {
        setIsLoading1(false);
      }
      if (responseJSON.status.toString() === "200") {
        const responseData = responseJSON.data;
        console.log("getAllCPS");
        console.log(responseData);
        setAllCPs(responseData);
        setIsLoading1(false);
      }
    } catch (error) {
      console.log("Error getting data: ", error);
      setAllCPs([]);
      setIsLoading1(false);
    }
  };

  // useEffect(() => {
  //     getAllCPS();
  // }, [global.tokens]);

  return (
    <>
      <Routes>
        <Route
          path=""
          element={<Login objectToFormData={objectToFormData} />}
        />
        <Route
          path="/login"
          element={<Login objectToFormData={objectToFormData} />}
        />
        <Route
          path="/forgotpassword"
          element={<ForgotPassword objectToFormData={objectToFormData} />}
        />
        {/* <Route path="*" element={<NotFound />} /> */}

        <Route
          path="/dashboard"
          element={
            <AdminPrivateRoutes>
              <Index
                Helmet={Helmet}
                capitalizeWords={capitalizeWords}
                isAuthExpired={isAuthExpired}
                objectToFormData={objectToFormData}
                yesterday={yesterday}
                today={today}
                resetTimeToMidnight={resetTimeToMidnight}
                resetTimeToB4Midnight={resetTimeToB4Midnight}
                formatDate={formatDate1}
                allCPs={allCPs}
                isLoading1={isLoading1}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </AdminPrivateRoutes>
          }
        />

        <Route
          path="/dashboard/marketer"
          element={
            <PrivateRoutes redirectTo="/login">
              <SingleMarketerDashboard
                Helmet={Helmet}
                capitalizeWords={capitalizeWords}
                isAuthExpired={isAuthExpired}
                objectToFormData={objectToFormData}
                yesterday={yesterday}
                today={today}
                resetTimeToMidnight={resetTimeToMidnight}
                resetTimeToB4Midnight={resetTimeToB4Midnight}
                formatDate={formatDate1}
                allCPs={allCPs}
                isLoading1={isLoading1}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/dashboard/company"
          element={
            <CompanyDashboardPrivateRoutes>
              <CompanyDashboard
                Helmet={Helmet}
                capitalizeWords={capitalizeWords}
                isAuthExpired={isAuthExpired}
                objectToFormData={objectToFormData}
                yesterday={yesterday}
                today={today}
                resetTimeToMidnight={resetTimeToMidnight}
                resetTimeToB4Midnight={resetTimeToB4Midnight}
                formatDate={formatDate1}
                allCPs={allCPs}
                isLoading1={isLoading1}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </CompanyDashboardPrivateRoutes>
          }
        />
        <Route
          path="/company/analytics"
          element={
            <PrivateRoutes redirectTo="/login">
              <IndividualCompanyDashboard
                Helmet={Helmet}
                capitalizeWords={capitalizeWords}
                isAuthExpired={isAuthExpired}
                objectToFormData={objectToFormData}
                yesterday={yesterday}
                today={today}
                resetTimeToMidnight={resetTimeToMidnight}
                resetTimeToB4Midnight={resetTimeToB4Midnight}
                formatDate={formatDate1}
                allCPs={allCPs}
                isLoading1={isLoading1}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/marketer/create"
          element={
            <PrivateRoutes redirectTo="/login">
              <CreateMarketers
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />

        <Route
          path="/test"
          element={
            <PrivateRoutes redirectTo="/login">
              <TestModule
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/filter/data"
          element={
            <PrivateRoutes redirectTo="/login">
              <FilterData
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />

         <Route
          path="/download/data"
          element={
            <PrivateRoutes redirectTo="/login">
              <DownloadData
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />

        <Route
          path="/revenue"
          element={
            //  <PrivateRoutes redirectTo="/login">
            <RevenueReport
              Helmet={Helmet}
              objectToFormData={objectToFormData}
              capitalizeWords={capitalizeWords}
              errorFunction={errorFunction}
              isAuthExpired={isAuthExpired}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
            />
            //  </PrivateRoutes>
          }
        />
        <Route
          path="/company"
          element={
            <PrivateRoutes redirectTo="/login">
              <ListOfCompany
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/company/create"
          element={
            <PrivateRoutes redirectTo="/login">
              <CreateCompany
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/company/update"
          element={
            <PrivateRoutes redirectTo="/login">
              <UpdateCompany
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/company/delete"
          element={
            <PrivateRoutes redirectTo="/login">
              <DeleteCompany
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/marketers"
          element={
            <PrivateRoutes redirectTo="/login">
              <ListOfMarketers
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/marketer/edit"
          element={
            <PrivateRoutes redirectTo="/login">
              <UpdateMarketer
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/marketer/delete"
          element={
            <PrivateRoutes redirectTo="/login">
              <DeleteMarketer
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />
        <Route
          path="/marketer/details"
          element={
            <PrivateRoutes redirectTo="/login">
              <MarketerDetails
                Helmet={Helmet}
                objectToFormData={objectToFormData}
                capitalizeWords={capitalizeWords}
                errorFunction={errorFunction}
                isAuthExpired={isAuthExpired}
                isLoaded={isLoaded}
                setIsLoaded={setIsLoaded}
              />
            </PrivateRoutes>
          }
        />

        <Route
          path="/products"
          element={
            <AdminPrivateRoutes>
              <ListOfProducts
                isLoaded={isLoaded}
                capitalizeWords={capitalizeWords}
              />
            </AdminPrivateRoutes>
          }
        />
        <Route
          path="/products/create"
          element={
            <AdminPrivateRoutes>
              <CreateProduct isLoaded={isLoaded} />
            </AdminPrivateRoutes>
          }
        />
        <Route
          path="/products/update"
          element={
            <AdminPrivateRoutes>
              <UpdateProduct isLoaded={isLoaded} />
            </AdminPrivateRoutes>
          }
        />
        <Route
          path="/products/delete"
          element={
            <AdminPrivateRoutes>
              <DeleteProduct isLoaded={isLoaded} />
            </AdminPrivateRoutes>
          }
        />

        {/* <Route
          path="/marketer/analytics"
          element={
            // <PrivateRoutes redirectTo="/login">
            <MarketersDashboard
              Helmet={Helmet}
              capitalizeWords={capitalizeWords}
              isAuthExpired={isAuthExpired}
              objectToFormData={objectToFormData}
              yesterday={yesterday}
              today={today}
              resetTimeToMidnight={resetTimeToMidnight}
              resetTimeToB4Midnight={resetTimeToB4Midnight}
              formatDate={formatDate1}
              allCPs={allCPs}
              isLoading1={isLoading1}
              isLoaded={isLoaded}
              setIsLoaded={setIsLoaded}
            />
            // </PrivateRoutes>
          }
        /> */}
      </Routes>
    </>
  );
}
